// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__TU1\\+a.styles_ocean-50__yqO0c {
  color: #e6f2ff;
}

.styles_color__TU1\\+a.styles_ocean-100__nPu-p {
  color: #e6f2ff;
}

.styles_color__TU1\\+a.styles_ocean-200__ggm\\+U {
  color: #b3daff;
}

.styles_color__TU1\\+a.styles_ocean-300__1oNQS {
  color: #7abfff;
}

.styles_color__TU1\\+a.styles_ocean-400__frsW0 {
  color: #2392fb;
}

.styles_color__TU1\\+a.styles_ocean-500__dzNGY {
  color: #0074e0;
}

.styles_color__TU1\\+a.styles_ocean-600__GA4cn {
  color: #043571;
}

.styles_color__TU1\\+a.styles_space-50__1py2v {
  color: #f0f0f0;
}

.styles_color__TU1\\+a.styles_space-100__Z9Shb {
  color: #e3e3e3;
}

.styles_color__TU1\\+a.styles_space-200__pUhGB {
  color: #bfbfbf;
}

.styles_color__TU1\\+a.styles_space-300__sJkYU {
  color: gray;
}

.styles_color__TU1\\+a.styles_space-400__DatSC {
  color: #616161;
}

.styles_color__TU1\\+a.styles_space-500__lTT7F {
  color: #283439;
}

.styles_color__TU1\\+a.styles_gray-50__6BnhQ {
  color: #eff3f6;
}

.styles_color__TU1\\+a.styles_gray-100__6XBrx {
  color: #e6ecef;
}

.styles_color__TU1\\+a.styles_gray-200__F\\+Unk {
  color: #cfd8de;
}

.styles_color__TU1\\+a.styles_gray-300__6tZaa {
  color: #a8b9c2;
}

.styles_color__TU1\\+a.styles_gray-400__6Yhbh {
  color: #7e98a5;
}

.styles_color__TU1\\+a.styles_gray-500__XEIqL {
  color: #738f9c;
}

.styles_color__TU1\\+a.styles_green-50__yYFX5 {
  color: #e3fdf6;
}

.styles_color__TU1\\+a.styles_green-100__cO\\+Ce {
  color: #c5f6ea;
}

.styles_color__TU1\\+a.styles_green-200__oemrU {
  color: #69ddc2;
}

.styles_color__TU1\\+a.styles_green-300__7drMK {
  color: #45bfa3;
}

.styles_color__TU1\\+a.styles_green-400__d572d {
  color: #1cab8a;
}

.styles_color__TU1\\+a.styles_green-500__ifSKe {
  color: #128268;
}

.styles_color__TU1\\+a.styles_red-50__6NOkM {
  color: #fff0f3;
}

.styles_color__TU1\\+a.styles_red-100__arQL9 {
  color: #f9d2db;
}

.styles_color__TU1\\+a.styles_red-200__OrKKq {
  color: #f8b4c4;
}

.styles_color__TU1\\+a.styles_red-300__WTfXV {
  color: #e85e81;
}

.styles_color__TU1\\+a.styles_red-400__LiEIA {
  color: #e23661;
}

.styles_color__TU1\\+a.styles_red-500__YhRKg {
  color: #b82348;
}

.styles_color__TU1\\+a.styles_yellow-50__grQAj {
  color: #fffae6;
}

.styles_color__TU1\\+a.styles_yellow-100__Wmw5G {
  color: #fff0b3;
}

.styles_color__TU1\\+a.styles_yellow-200__azP97 {
  color: #ffe380;
}

.styles_color__TU1\\+a.styles_yellow-300__jqI8C {
  color: #ffcf57;
}

.styles_color__TU1\\+a.styles_yellow-400__VH\\+tH {
  color: #ffc60a;
}

.styles_color__TU1\\+a.styles_yellow-500__h1rM2 {
  color: #ffb700;
}

.styles_color__TU1\\+a.styles_orange-50__tSYCT {
  color: #fff2eb;
}

.styles_color__TU1\\+a.styles_orange-100__9swm6 {
  color: #ffe4d6;
}

.styles_color__TU1\\+a.styles_orange-200__oZ4uo {
  color: #ffc69e;
}

.styles_color__TU1\\+a.styles_orange-300__2cfL1 {
  color: #ffa047;
}

.styles_color__TU1\\+a.styles_orange-400__e0-5v {
  color: #ff7b42;
}

.styles_color__TU1\\+a.styles_orange-500__jt2TF {
  color: #ee4920;
}

.styles_color__TU1\\+a.styles_turquoise-50__notp1 {
  color: transparent;
}

.styles_color__TU1\\+a.styles_turquoise-100__ks7Gd {
  color: #e6fcff;
}

.styles_color__TU1\\+a.styles_turquoise-200__HXhtf {
  color: #b3f5ff;
}

.styles_color__TU1\\+a.styles_turquoise-300__pyUQ1 {
  color: #78e2f2;
}

.styles_color__TU1\\+a.styles_turquoise-400__K9faw {
  color: #00c7e6;
}

.styles_color__TU1\\+a.styles_turquoise-500__FsWI9 {
  color: transparent;
}

.styles_color__TU1\\+a.styles_turquoise-600__\\+iQrc {
  color: transparent;
}

.styles_color__TU1\\+a.styles_violet-50__9AXvQ {
  color: #eae6ff;
}

.styles_color__TU1\\+a.styles_violet-100__EUap- {
  color: #d9d1ff;
}

.styles_color__TU1\\+a.styles_violet-200__ssTUR {
  color: #bfb3ff;
}

.styles_color__TU1\\+a.styles_violet-300__Wmnls {
  color: #9d90ea;
}

.styles_color__TU1\\+a.styles_violet-400__w3oVq {
  color: #8678d9;
}

.styles_color__TU1\\+a.styles_violet-500__UGLW1 {
  color: #6f5ccc;
}

.styles_color__TU1\\+a.styles_snow-50__wOx2c {
  color: white;
}

.styles_color__TU1\\+a.styles_snow-100__RetEA {
  color: #f7f7f7;
}

.styles_color__TU1\\+a.styles_snow-200__rPkSX {
  color: #f0efef;
}

.styles_color__TU1\\+a.styles_snow-300__jucsT {
  color: #e6e6e6;
}

.styles_color__TU1\\+a.styles_snow-400__TNipv {
  color: #e1e0e0;
}

.styles_color__TU1\\+a.styles_snow-500__CzI7f {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__Cfh\\+p.styles_ocean__lYweV {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_ocean-light__mf\\+vY {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_green__L4ElZ {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_green-light__hxMpv {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_red__vac7X {
  background-color: #e23661;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_red-light__hyFin {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_orange__0QTsY {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_orange-light__7B\\+gH {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_space__ePiGr {
  background-color: #616161;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_space-light__HbPP4 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__Cfh\\+p.styles_gray-light__H45r4 {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__Cfh\\+p.styles_violet__ctm1V {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_violet-light__T-KvY {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__Cfh\\+p.styles_yellow__dIfBE {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__Cfh\\+p.styles_yellow-light__-o6Gt {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__nyYHc {
  position: fixed;
  z-index: 9999;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/draggable/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,eAAA;EACA,aAAA;AA0UJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    position: fixed;\n    z-index: theme.get-z-index(draggable);\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__TU1+a`,
	"ocean-50": `styles_ocean-50__yqO0c`,
	"ocean-100": `styles_ocean-100__nPu-p`,
	"ocean-200": `styles_ocean-200__ggm+U`,
	"ocean-300": `styles_ocean-300__1oNQS`,
	"ocean-400": `styles_ocean-400__frsW0`,
	"ocean-500": `styles_ocean-500__dzNGY`,
	"ocean-600": `styles_ocean-600__GA4cn`,
	"space-50": `styles_space-50__1py2v`,
	"space-100": `styles_space-100__Z9Shb`,
	"space-200": `styles_space-200__pUhGB`,
	"space-300": `styles_space-300__sJkYU`,
	"space-400": `styles_space-400__DatSC`,
	"space-500": `styles_space-500__lTT7F`,
	"gray-50": `styles_gray-50__6BnhQ`,
	"gray-100": `styles_gray-100__6XBrx`,
	"gray-200": `styles_gray-200__F+Unk`,
	"gray-300": `styles_gray-300__6tZaa`,
	"gray-400": `styles_gray-400__6Yhbh`,
	"gray-500": `styles_gray-500__XEIqL`,
	"green-50": `styles_green-50__yYFX5`,
	"green-100": `styles_green-100__cO+Ce`,
	"green-200": `styles_green-200__oemrU`,
	"green-300": `styles_green-300__7drMK`,
	"green-400": `styles_green-400__d572d`,
	"green-500": `styles_green-500__ifSKe`,
	"red-50": `styles_red-50__6NOkM`,
	"red-100": `styles_red-100__arQL9`,
	"red-200": `styles_red-200__OrKKq`,
	"red-300": `styles_red-300__WTfXV`,
	"red-400": `styles_red-400__LiEIA`,
	"red-500": `styles_red-500__YhRKg`,
	"yellow-50": `styles_yellow-50__grQAj`,
	"yellow-100": `styles_yellow-100__Wmw5G`,
	"yellow-200": `styles_yellow-200__azP97`,
	"yellow-300": `styles_yellow-300__jqI8C`,
	"yellow-400": `styles_yellow-400__VH+tH`,
	"yellow-500": `styles_yellow-500__h1rM2`,
	"orange-50": `styles_orange-50__tSYCT`,
	"orange-100": `styles_orange-100__9swm6`,
	"orange-200": `styles_orange-200__oZ4uo`,
	"orange-300": `styles_orange-300__2cfL1`,
	"orange-400": `styles_orange-400__e0-5v`,
	"orange-500": `styles_orange-500__jt2TF`,
	"turquoise-50": `styles_turquoise-50__notp1`,
	"turquoise-100": `styles_turquoise-100__ks7Gd`,
	"turquoise-200": `styles_turquoise-200__HXhtf`,
	"turquoise-300": `styles_turquoise-300__pyUQ1`,
	"turquoise-400": `styles_turquoise-400__K9faw`,
	"turquoise-500": `styles_turquoise-500__FsWI9`,
	"turquoise-600": `styles_turquoise-600__+iQrc`,
	"violet-50": `styles_violet-50__9AXvQ`,
	"violet-100": `styles_violet-100__EUap-`,
	"violet-200": `styles_violet-200__ssTUR`,
	"violet-300": `styles_violet-300__Wmnls`,
	"violet-400": `styles_violet-400__w3oVq`,
	"violet-500": `styles_violet-500__UGLW1`,
	"snow-50": `styles_snow-50__wOx2c`,
	"snow-100": `styles_snow-100__RetEA`,
	"snow-200": `styles_snow-200__rPkSX`,
	"snow-300": `styles_snow-300__jucsT`,
	"snow-400": `styles_snow-400__TNipv`,
	"snow-500": `styles_snow-500__CzI7f`,
	"background-color": `styles_background-color__Cfh+p`,
	"ocean": `styles_ocean__lYweV`,
	"ocean-light": `styles_ocean-light__mf+vY`,
	"green": `styles_green__L4ElZ`,
	"green-light": `styles_green-light__hxMpv`,
	"red": `styles_red__vac7X`,
	"red-light": `styles_red-light__hyFin`,
	"orange": `styles_orange__0QTsY`,
	"orange-light": `styles_orange-light__7B+gH`,
	"space": `styles_space__ePiGr`,
	"space-light": `styles_space-light__HbPP4`,
	"gray-light": `styles_gray-light__H45r4`,
	"violet": `styles_violet__ctm1V`,
	"violet-light": `styles_violet-light__T-KvY`,
	"yellow": `styles_yellow__dIfBE`,
	"yellow-light": `styles_yellow-light__-o6Gt`,
	"root": `styles_root__nyYHc`
};
export default ___CSS_LOADER_EXPORT___;
